/**
 * Ana's mark, as it appears on longhitravel.com.
 *
 * Her actual asset rather than my redraw. The earlier version was a geometric L
 * I drew to match a font I had guessed at; this is the gold script L in its
 * compass ring, with the wordmark and the diamond rule, exactly as her clients
 * already know it. A traveller opening an itinerary link should not be able to
 * tell they have left her website.
 *
 * The navy ground has been made transparent and the image trimmed to content,
 * so the mark sits on the hero without reading as a pasted-on card — which is
 * exactly how it looked before, and the first thing that gave the page away as
 * software rather than her letterhead.
 */
export function Logo({
  variant = 'mark',
  className = '',
}: {
  /** `mark` crops to the roundel; `full` includes the wordmark and rule. */
  variant?: 'mark' | 'full'
  className?: string
}) {
  if (variant === 'full') {
    return (
      <img
        src="/longhi-travel.png"
        alt="Longhi Travel"
        width={300}
        height={200}
        className={`h-auto w-[220px] max-w-full ${className}`}
      />
    )
  }

  // The roundel alone, for the nav. One image serves both, so the crop is a
  // viewport rather than a second file: the roundel sits in the top ~62% of the
  // trimmed art, centred horizontally.
  return (
    <span
      aria-label="Longhi Travel"
      role="img"
      className={`inline-block overflow-hidden ${className}`}
      style={{ width: 30, height: 30 }}
    >
      <img
        src="/longhi-travel.png"
        alt=""
        aria-hidden="true"
        style={{
          width: 55,
          height: 34,
          objectFit: 'none',
          objectPosition: '-12px 0px',
          maxWidth: 'none',
        }}
      />
    </span>
  )
}
